/** Collection eligibility is independent of occupancy and future billing.
 * Notice-period tenants remain tracked until their terminal status. */
export const RENT_COLLECTION_STATUSES = [
  "confirmed",
  "active",
  "approved",
  "notice_given",
  "move_out_pending",
];

export function isNoticePeriodStatus(status: string | null): boolean {
  return status === "notice_given" || status === "move_out_pending";
}

export interface CollectionBooking {
  status: string | null;
  admin_archived_at?: string | null;
  actual_move_in_date?: string | null;
  move_in_date?: string | null;
  start_date?: string | null;
  actual_move_out_date?: string | null;
  move_out_date?: string | null;
  end_date?: string | null;
}

export function isRentCollectionEligible(
  booking: CollectionBooking,
  now: Date = new Date(),
  options: { allowFutureArrival?: boolean } = {}
): boolean {
  if (booking.admin_archived_at != null) return false;
  if (!RENT_COLLECTION_STATUSES.includes(booking.status ?? "")) return false;
  const start =
    booking.actual_move_in_date ?? booking.move_in_date ?? booking.start_date;
  if (!options.allowFutureArrival && start && Date.parse(start) > now.getTime())
    return false;
  // Preserve the existing departure cutoff outside the two notice statuses.
  const end = booking.actual_move_out_date ?? booking.move_out_date;
  if (
    !isNoticePeriodStatus(booking.status) &&
    end &&
    Date.parse(end) < now.getTime()
  )
    return false;
  return true;
}
